import React from "react"
import {Home,
        Users,
        Archive,
        AlertCircle,
        Map,
        Settings,
        FileText,
        UserCheck,
        Clock,
        Server} from "react-feather"
const navigationConfig = [
  {
    id: "home",
    title: "Home",
    type: "item",
    icon: <Home size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/"
  },
  {
    id: "users",
    title: "Users",
    type: "item",
    icon: <Users size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/users"
  },
  {
    id: "locations",
    title: "Locations",
    type: "item",
    icon: <Map size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/locations"
  },
  {
    id: "activity",
    title: "Activity",
    type: "item",
    icon: <Archive size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/activity"
  },
  {
    id: "alerts",
    title: "Alerts",
    type: "item",
    icon: <AlertCircle size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/alerts"
  },
  {
    id: "expiredLockers",
    title: "Expired Lockers",
    type: "item",
    icon: <Clock size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/expired-lockers"
  },
  {
    id: "adminsLogs",
    title: "Admins Logs",
    type: "item",
    icon: <FileText size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/admins/logs"
  },
  {
    id: "locationsDetails",
    title: null,
    type: "hidden",
    icon: null,
    permissions: ["admin", "editor"],
    navLink: "/locations/details/:id"
  },
  {
    id: "administration",
    title: "Administration",
    icon: <Settings size={20} />,
    type: "collapse",
    children: [
      {
        id: "admins",
        title: "Admins",
        type: "item",
        icon: <UserCheck size={16} />,
        permissions: ["admin", "editor"],
        navLink: "/admins"
      },
      /*{
        id: "projects",
        title: "Projects",
        type: "item",
        icon: <Disc size={16} />,
        permissions: ["admin", "editor"],
        navLink: "/projects"
      },
      {
        id: "userType",
        title: "User Type",
        type: "item",
        icon: <Disc size={16} />,
        permissions: ["admin", "editor"],
        navLink: "/user-type"
      },
      {
        id: "service",
        title: "Service",
        type: "item",
        icon: <Disc size={16} />,
        permissions: ["admin", "editor"],
        navLink: "/service"
      }*/
    ]
  },
  {
    id: "usersDetails",
    title: null,
    type: "hidden",
    icon: null,
    permissions: ["admin", "editor"],
    navLink: "/users/details/:id"
  },
  /*{
    id: "serviceStatus",
    title: "Service Status",
    type: "item",
    icon: <Server size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/service-status"
  },*/
  /*{
  id: "support",
  title: "Support",
  type: "item",
  icon: <LifeBuoy size={20} />
  },
  {
    id: "docs",
    title: "Documentation",
    type: "item",
    icon: <FileText size={20} />,
    permissions: ["admin", "editor"],
  },
  {
    id: "faq",
    title: "FAQ",
    type: "item",
    icon: <HelpCircle size={20} />,
    permissions: ["admin"],
  }*/
]

export default navigationConfig
